module.exports = __webpack_public_path__ + "static/media/GDL.deff3eb7.png";